export const useRemoteWrapperProps = ({ className, widget, batching, groupId, widgetId }) => ({
    className,
    'data-id': widgetId,
    'data-group-id': groupId !== null && groupId !== void 0 ? groupId : (batching ? 'main' : undefined),
    'data-remote': widget,
    suppressHydrationWarning: true,
});
